
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mparticle",
      function () {
        return require("private-next-pages/destinations/mparticle.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mparticle"])
      });
    }
  